import React from 'react';
import SEO from '../../components/SEO';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import IndustryHero from '../../components/industries/IndustryHero';
import IndustryContent from '../../components/industries/IndustryContent';
import IndustryCTA from '../../components/industries/IndustryCTA';

const RealEstate = () => {
  const industryData = {
    title: 'Real Estate',
    subtitle: 'Digital solutions for modern real estate',
    description: 'Transform your real estate business with cutting-edge technology. From property management platforms to virtual tours and marketplace solutions, we build digital products that revolutionize how properties are bought, sold, and managed.',
    challenges: [
      {
        title: 'Property Management',
        description: 'Streamline operations with comprehensive property management systems that handle everything from tenant communications to maintenance scheduling.'
      },
      {
        title: 'Virtual Tours & 3D Visualization',
        description: 'Create immersive property experiences with 3D tours, virtual staging, and augmented reality applications that help buyers visualize their future homes.'
      },
      {
        title: 'Marketplace Platforms',
        description: 'Build robust real estate marketplaces that connect buyers, sellers, agents, and investors with powerful search and recommendation engines.'
      },
      {
        title: 'Investment Analytics',
        description: 'Develop sophisticated analytics tools that help investors make data-driven decisions with market insights and property valuation models.'
      }
    ],
    services: [
      'Custom CRM and Property Management Systems',
      'Real Estate Marketplace Development',
      '3D Visualization and Virtual Tour Platforms',
      'Mobile Apps for Agents and Buyers',
      'Investment Analysis Tools',
      'Document Management and E-Signature Integration'
    ],
    technologies: ['React', 'Node.js', 'Python', 'PostgreSQL', 'AWS', 'Three.js', 'GIS APIs']
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Real Estate Technology Solutions"
        description="Digital solutions for real estate — property platforms, PropTech apps, and custom software for brokers, developers, and property management companies."
        path="/industries/real-estate"
      />
      <Header />
      <IndustryHero data={industryData} />
      <IndustryContent data={industryData} />
      <IndustryCTA industry="Real Estate" />
      <Footer />
    </div>
  );
};

export default RealEstate;
